import { render } from "./ViewMorePayment.vue?vue&type=template&id=095b924d&scoped=true"
import script from "./ViewMorePayment.vue?vue&type=script&lang=js"
export * from "./ViewMorePayment.vue?vue&type=script&lang=js"

import "./ViewMorePayment.vue?vue&type=style&index=0&id=095b924d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095b924d"]])

export default __exports__